/**
 * Listing filters, sorting, toggles.
 */
export default function initFilters() {}
